"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeMultiSelect = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const BadgeMultiSelectDropdownContent_1 = require("./BadgeMultiSelectDropdownContent");
const BadgeMultiSelectFieldContent_1 = require("./BadgeMultiSelectFieldContent");
const BadgeMultiSelect = (props) => {
    const { value, setValue, items, toItem, label, hidden, modificators, additionClassNames, } = props;
    return (react_1.default.createElement(__1.MultiSelect, { dropdownContent: react_1.default.createElement(BadgeMultiSelectDropdownContent_1.BadgeMultiSelectDropdownContent, { value: value, setValue: setValue, items: items, toItem: toItem }), fieldContent: (react_1.default.createElement(BadgeMultiSelectFieldContent_1.BadgeMultiSelectFieldContent, { value: value, setValue: setValue, toItem: toItem })), label: label, hidden: hidden, modificators: modificators, additionClassNames: additionClassNames }));
};
exports.BadgeMultiSelect = BadgeMultiSelect;
//# sourceMappingURL=index.js.map